module.exports = __webpack_public_path__ + "img/id-verifing.ef120c51.png";